export default __webpack_public_path__ + "static/media/bizum.413d4080.svg";